<template>
  <div ref="selectContainer" style="position: relative;width:100%">
    <div style="width:100%;display: flex">
      <modal-text-input
        :id="id"
        :label="label"
        :modelValue="modelValue"
        @update:modelValue="this.debounceChange"
        @click="() => (this.isListVisible = true)"
        :errorMessage="errorMessage"
        :disabled="disabled"
      />

      <modal-input-action-button
        :class="[{ 'is-invalid-btn': !!errorMessage }]"
        style="position: relative; top: 3px; right: -7px; height: 29px"
        value="▼"
        @click="() => (this.isListVisible = !this.isListVisible)"
        :disabled="disabled"
      />
    </div>

    <ul v-if="isListVisible" class="list">
      <li
        v-if="Object.keys(options).length === 0"
        style="background-color: #ced4da"
      >
        Sem resultados
      </li>
      <li
        v-else
        v-for="(option, label) in options"
        :value="option.value"
        :key="option.value"
        @click="($event) => selectItem($event)"
      >
        {{ truncate(label, 50) }}
      </li>
    </ul>
  </div>
</template>

<script>
import ModalInputActionButton from "./ModalInputActionButton.vue";
import ModalTextInput from "./ModalTextInput.vue";
import _ from "lodash";

export default {
  name: "ModalSearchSelectInput",
  components: {
    ModalInputActionButton,
    ModalTextInput,
  },
  props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: false,
      type: String,
    },
    modelValue: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Object,
    },
    errorMessage: {
      required: false,
      type: String,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      value: "",
      isListVisible: false,
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  computed: {
    debounceChange() {
      return _.debounce(this.change, 500);
    },
  },
  methods: {
    truncate(text, limit) {
      if (text.length > limit) {
        return text.substring(0, limit) + "...";
      }

      return text;
    },
    handleClickOutside(event) {
      if (!this.$refs.selectContainer.contains(event.target)) {
        this.isListVisible = false;
      }
    },
    // deve emitir apenas quando um item for selecionado na lista
    change(newValue) {
      this.$emit("update:modelValue", newValue);
      this.$emit("onUpdateList", newValue);
      this.isListVisible = true;
    },
    selectItem($event) {
      const selectedText = $event.target.textContent;
      const selectedValue = $event.target.getAttribute("value");
      this.$emit("onSelect", selectedValue.trim());
      this.$emit("update:modelValue", selectedText.trim());
      this.isListVisible = false;
    },
  },
};
</script>

<style scoped>
.list {
  background-color: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  position: absolute;
  width: 100%;
  z-index: 99;
  cursor: pointer;
  max-height: 200px;
  overflow-x: auto;
  top: 40px;
  overflow-x: hidden;
  list-style: none;
  padding: 0px;
}
.list li {
  padding: 5px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  text-align: left;
  height: 30px;
  width: 500px;
}
.list li:hover {
  padding: 5px;
  background-color: #ced4da;
}
.input-label {
  text-align: left;
  width: 100%;
}
.is-invalid-btn {
  border-color: red;
  color: red;
}
label {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #666;
  font-weight: bold;
  margin-bottom: 5px;
  text-align: left;
  width: 100%;
}
select {
  min-width: 200px;
  height: 30px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 11px;
  color: #333;
  font-weight: normal;
}
.error {
  color: red;
  width: 100%;
  display: block;
  margin: -7px 0px 0px 20px;
  text-align: left;
  font-size: 12px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ModalSearchSelectInput.vue